import React, { lazy } from "react";
import { Link } from "react-router-dom";
import Button2 from "../../common/Button2";
import FullWidthContainer from "../../common/FullWidthContainer";
import YoutubeVideo from "../../components/YoutubeVideo";
import Announcement from "../../components/Announcement";
// import AnnouncementTeaser from "../../components/AnnouncementTeaser";
import {HashLink} from "react-router-hash-link";

const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
const Intro = lazy(() => import("../../components/Intro"));
const IntroNeu = lazy(() => import("../../components/IntroNeu"));
const SectionLine = lazy(() => import("../../components/SectionLine"));
const BegehrenComponent = lazy(() => import("../../components/BegehrenComponent"));
const Sammelstellen = lazy(() => import("../../components/Sammelstellen"));
const SammelAufruf = lazy(() => import("../../components/SammelAufruf"));
const Supporter = lazy(() => import("../../components/Supporter"));
const WegeZurUnterschrift = lazy(() => import("../../components/WegeZurUnterschrift"));
const ListBlockImg = lazy(() => import("../../components/ListBlockImg"));
const Dashboard = lazy(() => import("../../components/Dashboard"));
const AnnouncementTeaser = lazy(() => import("../../components/AnnouncementTeaser"));
const AktuelleThemen = lazy(() => import("../../components/AktuelleThemen"));
const Downloads = lazy(() => import("../../components/Downloads"));

const Home = () => {
  return (
    <>

      <AnnouncementTeaser/>
      <IntroNeu/>

      {/* Scroll To Top Pfeil unten Rechts */}
      <ScrollToTop />

      {/* Aktuelle Themen */}
      <SectionLine how = "center"/>
      <AktuelleThemen/>
      
      {/* Sektion Image Film */}
      <SectionLine how = "left"/>
      <YoutubeVideo />

      {/* Dashboard aktueller Unterschriftenstand */}
      <SectionLine how = "right"/>
      <Dashboard/>
      

      {/* Unterstützungsaufruf */}
      <SectionLine how = "center"/>
      <SammelAufruf/>

      {/* Downloads */}
      <SectionLine how = "right"/>
      <Downloads/>



      <SectionLine how = "center"/>
      {/* Karte und Liste der Sammelstellen */}
      {/* <Sammelstellen/>
      <SectionLine how = "right"/> */}
      <div id = "downloads"/>


      {/* Unterstützende des Radentscheids */}
      <Supporter/>
      <SectionLine how = "center"/>

      {/* Schlussteil mit Weiterleitung FAQ */}
      <Container>
      <h1 style={{"textAlign":"center", "margin":"2em", "marginBottom":"0.5em"}}>Es sind noch Fragen offen geblieben?</h1>
      <div style = {{"display":"grid", "gridTemplateColumns":"1fr 1fr", "maxWidth":"600px","marginLeft":"auto", "marginRight":"auto", "marginBottom":"3em"}}>
        <HashLink to="./faq#top"><Button2 onClick = {() => {}} content = "Hier geht's zum FAQ!"/></HashLink>
        <HashLink to="./gute-gruende#top"><Button2 onClick = {() => {}} content = "100+ gute Gründe für den Radentscheid"/></HashLink>
      </div>
      </Container>

    </>
  );
};

export default Home;
